import { render, staticRenderFns } from "./NhlSummary.vue?vue&type=template&id=27b0d042&scoped=true"
import script from "./NhlSummary.vue?vue&type=script&lang=js"
export * from "./NhlSummary.vue?vue&type=script&lang=js"
import style0 from "./NhlSummary.vue?vue&type=style&index=0&id=27b0d042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0d042",
  null
  
)

export default component.exports